module.exports = __WEBPACK_EXTERNAL_MODULE_77__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/system/Capabilities","root":["openfl","system","Capabilities"],"commonjs":"openfl/system/Capabilities","commonjs2":"openfl/system/Capabilities"}
// module id = 77
// module chunks = 0